import { cloneDeep, merge, isArray } from 'lodash';

import { withClientToken } from '../../actions/helpers/tokenHelpers';
import {
  loginUser,
  forgotPassword,
  loginUserSession,
} from '../../actions/sagAuth';
import { registerUserToOrg, listOrgProfiles } from '../../actions/registration';
import history from '../../history';
import { ACTIONS as layoutActions } from '../layout';
// import { checkPasswordFormat } from '../../routes/signIn/utils';
import {
  saveCookieConsent,
  getCookieValue,
  saveAuthCookie,
  clearExtraAliasInfo, saveRedirectionCookie,
} from '../../utils/cookie';
import getPlatformUrl from '../../utils/login';
import {
  startPollingFor,
  setPollingTimeoutFor,
  resetPollingFor,
} from '../../actions/polling';
import poll from '../../utils/polling';
import { hashString } from '../../utils/stringUtil';

const getColor = txt => `#${hashString(txt).slice(-7, -1)}`;

const regFieldsMap = {
  name: 'name',
  email: 'email',
  role: 'currentRole',
  password: 'password',
  license_id: 'license_id',
};

const INIT = 'signIn/INIT';
const TOGGLE_FORM = 'signIn/TOGGLE_FORM';
const SET_VALUE_FOR = 'signIn/SET_VALUE_FOR';
const SET_ATTEMPTING_LOGIN = 'signIn/SET_ATTEMPTING_LOGIN';
const SET_SIGNIN_ERR = 'signIn/SET_SIGNIN_ERR';
const SET_SUBDOMAIN = 'signIn/SET_SUBDOMAIN';
const HANDLE_ERROR = 'signIn/HANDLE_ERROR';
const TOGGLE_FORGOT_PASS = 'signIn/TOGGLE_FORGOT_PASS';
const SUBMIT_FORGOT_PASS = 'signIn/SUBMIT_FORGOT_PASS';
const SET_FOR_PASS_FIELDS_VAL = 'signIn/SET_FOR_PASS_FIELDS_VAL';
const SET_REG_FIELDS = 'signIn/SET_REG_FIELDS';
const SET_PASS_ERRMSG = 'signIn/SET_PASS_ERRMSG';
const PASS_TXT_TYPE = 'signIn/PASS_TXT_TYPE';
const TOGGLE_DROPDOWN = 'signIn/TOGGLE_DROPDOWN';
const SELECT_FILTER = 'signIn/SELECT_FILTER';
const SET_REG_COMPLETE = 'signIn/SET_REG_COMPLETE';
const SET_COOKIE_MSG = 'signIn/SET_COOKIE_MSG';
const SET_ALIAS_INFO = 'signIn/SET_ALIAS_INFO';

const defaultState = {
  orgId: '',
  regFields: [],
  showRegister: false,
  signinErrMsg: '',
  regErrMsg: '',
  subdomain: '',
  setPassword: false,
  currentForm: 'register',
  forgotPass: false,
  cookieMsg: false,
  attemptingLogin: false,
  loginFields: {
    email: '',
    password: '',
  },
  registerFields: {},
  forgotPassFields: {
    email: '',
  },
  forgotPassSubmitted: false,
  passErrMsg: '',
  passwordTxtType: 'password',
  filterDropdown: false,
  currentRole: '',
  registerComplete: false,
  validationTxt: '',
  showRegForm: false,
  sessionId: '',
};

const initInternal = (
  orgId,
  regFields,
  showRegForm,
  registerFields,
  currentForm,
  roles,
) => ({
  type: INIT,
  orgId,
  regFields,
  showRegForm,
  registerFields,
  currentForm,
  roles,
});

const setLoginFields = fields => ({ type: SET_VALUE_FOR, fields });

const setAttemptingLogin = bool => ({ type: SET_ATTEMPTING_LOGIN, bool });

// const setSigninErr = err => ({ type: SET_SIGNIN_ERR, err });

const setSubdomain = domain => ({ type: SET_SUBDOMAIN, domain });

const submitForgotPass = bool => ({ type: SUBMIT_FORGOT_PASS, bool });

const setRegField = fields => ({ type: SET_REG_FIELDS, fields });

// const setPassErrMsg = passErrMsg => ({ type: SET_PASS_ERRMSG, passErrMsg });

const setForgotPassFieldVal = fields => ({
  type: SET_FOR_PASS_FIELDS_VAL,
  fields,
});

const setRegComplete = (bool, sessionId) => ({
  type: SET_REG_COMPLETE,
  bool,
  sessionId,
});

const setCookieMsg = bool => ({ type: SET_COOKIE_MSG, bool });

const setAliasInfo = validationTxt => ({
  type: SET_ALIAS_INFO,
  validationTxt,
});

const setLoginFieldsVal = (field, val) => (dispatch, getState) => {
  const { loginFields } = getState().routes.signIn;

  const clonedLoginFields = cloneDeep(loginFields);

  clonedLoginFields[field] = val;

  dispatch(setLoginFields(clonedLoginFields));
};

const setForgotPassField = (field, val) => (dispatch, getState) => {
  const { forgotPassFields } = getState().routes.signIn;

  const clonedforgotPassFields = cloneDeep(forgotPassFields);

  clonedforgotPassFields[field] = val;

  dispatch(setForgotPassFieldVal(clonedforgotPassFields));
};

const setRegFieldVal = (field, val) => (dispatch, getState) => {
  const { registerFields } = getState().routes.signIn;

  const clonedRegisterFields = cloneDeep(registerFields);

  clonedRegisterFields[field] = val;

  dispatch(setRegField(clonedRegisterFields));

  // if (field === 'password') {
  //   const passErrMsg = checkPasswordFormat(val);

  //   dispatch(setPassErrMsg(passErrMsg));
  // }
};

const redirectToSubdomain = subdomain => {
  const redirectUrl = getPlatformUrl({
    organizationSubdomain: subdomain,
    websiteHost: window.location.host,
  });

  window.location.replace(redirectUrl);
};

const generateApiDetails = (regFields, state) => {
  const { registerFields, currentRole } = state;

  const details = {};

  for (let i = regFields.length - 1; i >= 0; i -= 1) {
    const field = regFields[i];
    const stateKey = regFieldsMap[field];

    if (stateKey === 'currentRole') {
      details[field] = currentRole.value;
    } else {
      details[field] = registerFields[stateKey];
    }
  }

  return details;
};

const handleError = (error, errorCode) => {
  console.error(`API returned ${errorCode} status code:`, error);

  let errorMessage = 'Some error occured';

  if (error.errorMessage) {
    errorMessage = error.errorMessage;
  }

  if (typeof error === 'string') {
    errorMessage = error;
  }

  return { errorMessage, errorCode };
};

const regsiterUser = async (orgId, formDetails) => {
  try {
    const { error, errorCode, ...data } = await withClientToken({
      action: registerUserToOrg,
      args: [orgId, formDetails],
    });

    if (error) {
      const { errorMessage } = handleError(error, errorCode);
      return {
        error: errorMessage,
        sessionId: null,
      };
    }

    return {
      error: null,
      sessionId: data.session_id,
    };
  } catch (err) {
    console.error(err);
    return {
      error: 'Some error occured. Please try again later.',
      sessionId: null,
    };
  }
};

export const handleRedirection = (domainStatus, subdomain) => {
  if (domainStatus) {
    setTimeout(redirectToSubdomain(subdomain), 1000);
    return;
  }

  history.push('/redirect');
};

const handleLogin = () => async (dispatch, getState) => {
  saveCookieConsent(true);
  dispatch(setCookieMsg(false));

  const { loginFields } = getState().routes.signIn;

  const { email, password } = loginFields;

  if (!email) {
    return dispatch(
      layoutActions.setAlert("Email field can't be empty", 'danger'),
    );
  }

  if (!password) {
    return dispatch(
      layoutActions.setAlert("Password field can't be empty", 'danger'),
    );
  }

  dispatch(setAttemptingLogin(true));

  try {
    const { error, errorCode, ...data } = await withClientToken({
      action: loginUser,
      args: [email, password],
    });

    if (error) {
      if (errorCode === 403) {
        dispatch(layoutActions.setAlert(error.errorMessage, 'danger'));

        setTimeout(() => history.push('/change-password?title=Reset'), 2000);
      }
      dispatch(setAttemptingLogin(false));
      return dispatch(layoutActions.setAlert(error.errorMessage, 'danger'));
    }

    const {
      // refresh_token: refreshToken,
      subdomain_url: subdomain,
      // user_token: userToken,
      id: userId,
    } = data;

    const user = merge({}, data, { user_id: userId });
    delete user.user_token;
    delete user.refresh_token;
    delete user.redirection_token;
    delete user.id;

    saveAuthCookie(subdomain);

    const domainStatus = true;

    dispatch(setSubdomain(subdomain));
    clearExtraAliasInfo();
    // console.log({domainStatus, subdomain})
    handleRedirection(domainStatus, subdomain);
  } catch (err) {
    console.error(err);
    dispatch(setAttemptingLogin(false));
  }
};

const pollSessionLogin = (timeout = 5000) => (dispatch, getState) => {
  const { sessionId } = getState().routes.signIn;
  const { polling } = getState();

  // check if already polling
  if (polling.sessionLogin && polling.sessionLogin.isPolling) {
    dispatch(resetPollingFor('sessionLogin'));
  }

  dispatch(startPollingFor('sessionLogin'));

  const stopPolling = () => {
    dispatch(resetPollingFor('sessionLogin'));
  };

  let loginSuccessful = false;
  let subdomain = '';

  const timeoutId = poll(
    () =>
      loginUserSession(sessionId).then(
        ({ userToken, subdomain: orgSubD }) => {
          loginSuccessful = !!userToken;
          subdomain = orgSubD;
        },
      ),
    () => !loginSuccessful,
    (dummy, nextTimeoutId) =>
      dispatch(setPollingTimeoutFor('sessionLogin', nextTimeoutId)),
    error => {
      throw new Error(error);
    },
    () => {
      stopPolling();
      redirectToSubdomain(subdomain);
    },
    timeout,
  );

  dispatch(setPollingTimeoutFor('sessionLogin', timeoutId));
};

const handleRegister = () => async (dispatch, getState) => {
  const {
    registerFields,
    regFields,
    currentRole,
    orgId,
  } = getState().routes.signIn;

  const { password, password2, name, email } = registerFields;

  if (Object.keys(registerFields).includes('name') && !name) {
    return dispatch(
      layoutActions.setAlert("Name field can't be empty", 'danger'),
    );
  }

  if (Object.keys(registerFields).includes('email') && !email) {
    return dispatch(
      layoutActions.setAlert("Email field can't be empty", 'danger'),
    );
  }

  if (
    Object.keys(registerFields).includes('role') &&
    (!currentRole || currentRole === 'Select Role')
  ) {
    return dispatch(layoutActions.setAlert('Please select a role', 'danger'));
  }

  if (Object.keys(registerFields).includes('license_id') && !currentRole) {
    return dispatch(layoutActions.setAlert('No valid license found', 'danger'));
  }

  if (Object.keys(registerFields).includes('password') && !password) {
    return dispatch(
      layoutActions.setAlert("Password can't be empty", 'danger'),
    );
  }

  const extraAliasInfo = getCookieValue('extra_alias_info');

  if (Object.keys(registerFields).includes('password') && extraAliasInfo) {
    const parsedExtraAliasInfo = JSON.parse(extraAliasInfo);

    const { passwordRegex, showRegForm, validationTxt } = parsedExtraAliasInfo;

    const correctPass = RegExp(passwordRegex).test(registerFields.password);

    if (!correctPass) {
      return dispatch(setAliasInfo(validationTxt));
    }
  }

  if (
    Object.keys(registerFields).includes('password') &&
    password !== password2
  ) {
    return dispatch(layoutActions.setAlert("Passwords don't match", 'danger'));
  }

  const details = generateApiDetails(regFields, getState().routes.signIn);

  let responseOrgId = '';

  if (extraAliasInfo) {
    responseOrgId = JSON.parse(extraAliasInfo).responseOrgId;
  }

  dispatch(setAttemptingLogin(true));

  try {
    const { error, sessionId } = await regsiterUser(
      responseOrgId || orgId,
      details,
    );

    // sessionId will be used for polling..
    if (error) {
      dispatch(setRegComplete(false));
      dispatch(setAttemptingLogin(false));
      dispatch(layoutActions.setAlert(error, 'danger'));
    } else {
      dispatch(setAttemptingLogin(false));
      dispatch(setRegComplete(true, sessionId));
      clearExtraAliasInfo();
      dispatch(pollSessionLogin());
    }
  } catch (err) {
    console.error(err);
    setAttemptingLogin(false);
    dispatch(setRegComplete(false));
    dispatch(layoutActions.setAlert(err.errorMessage, 'danger'));
  }
};

const handleForgotPassword = () => async (dispatch, getState) => {
  dispatch(setAttemptingLogin(true));

  const { forgotPassFields } = getState().routes.signIn;

  const { email } = forgotPassFields;

  if (!email) {
    return dispatch(layoutActions.setAlert('Please enter email', 'danger'));
  }

  try {
    const { error, errorCode } = await withClientToken({
      action: forgotPassword,
      args: [email],
    });

    if (error) {
      dispatch(
        layoutActions.setAlert(
          'Some error occured. Please try again later',
          'success',
        ),
      );
    }

    dispatch(submitForgotPass(true));
    dispatch(setAttemptingLogin(false));
  } catch (err) {
    console.error(err);
    dispatch(setAttemptingLogin(false));
    dispatch(
      layoutActions.setAlert(
        'Some error eccured. Please try after some time',
        'danger',
      ),
    );
  }
};

const enterPressHandler = compType => dispatch => {
  if (compType === 'login') {
    dispatch(handleLogin());
  }

  if (compType === 'register') {
    dispatch(handleRegister());
  }
};

const promptCookie = () => dispatch => {
  const cookieConsent = getCookieValue('cookie_consent');

  if (cookieConsent) {
    dispatch(handleLogin());
  } else {
    dispatch(setCookieMsg(true));
  }
};

const declineCookie = () => dispatch => {
  dispatch(setCookieMsg(false));
};

const errorOpts = (error, errorCode, errType) => {
  console.error(`API returned ${errorCode} status code:`, error);

  let errorMessage = 'Some error occured';

  if (error.detail) {
    errorMessage = error.detail;
  }

  if (error.email) {
    errorMessage = error.email[0];
  }

  if (error.message) {
    errorMessage = error.message;
  }

  if (error.errorMessage && isArray(error.errorMessage)) {
    errorMessage = error.errorMessage[0];
  }

  if (error.errorMessage && typeof error.errorMessage === 'string') {
    errorMessage = error.errorMessage;
  }

  if (typeof error === 'string') {
    errorMessage = error;
  }

  if (errType === 'login') {
    return {
      signinErrMsg: errorMessage,
      attemptingLogin: false,
    };
  }

  return {
    regErrMsg: errorMessage,
    attemptingLogin: false,
  };
};

const init = ({ apiData }) => async dispatch => {
  const { regFields, orgId, showRegister } = apiData;

  const registerFields = {};

  regFields.forEach(d => {
    registerFields[d] = '';
  });

  registerFields.password2 = '';

  let showRegForm = true;

  const extraAliasInfo = getCookieValue('extra_alias_info');

  if (extraAliasInfo) {
    const parsedInfo = JSON.parse(extraAliasInfo);
    showRegForm = parsedInfo.showRegForm;
  }

  let mappedRoles = [];

  if (orgId) {
    showRegForm = !!orgId;

    try {
      const { roles, error } = await withClientToken({
        action: listOrgProfiles,
        args: [orgId],
      });

      mappedRoles =
        roles &&
        roles.length &&
        roles.map(role => ({
          value: role.role.name,
          label: role.role.name,
          id: role.role.profile_id,
          color: getColor(role.role.name),
        }));

      dispatch(
        initInternal(
          orgId,
          regFields,
          showRegForm,
          registerFields,
          orgId ? 'register' : 'login',
          mappedRoles,
        ),
      );
    } catch (err) {
      console.error(err);
    }
  } else {
    dispatch(
      initInternal(
        orgId,
        regFields,
        showRegForm,
        registerFields,
        orgId ? 'register' : 'login',
      ),
    );
  }
};

export const ACTIONS = {
  init,
  toggleForm: form => ({ type: TOGGLE_FORM, form }),
  toggleForgotPass: bool => ({ type: TOGGLE_FORGOT_PASS, bool }),
  changePassTxtType: () => ({ type: PASS_TXT_TYPE }),
  toggleDropDown: bool => ({ type: TOGGLE_DROPDOWN, bool }),
  selectFilter: role => ({ type: SELECT_FILTER, role }),
  setLoginFieldsVal,
  handleLogin,
  enterPressHandler,
  handleForgotPassword,
  setForgotPassField,
  submitForgotPass,
  setRegFieldVal,
  handleRegister,
  promptCookie,
  declineCookie,
};

function signIn(state = defaultState, action) {
  switch (action.type) {
    case INIT:
      return Object.assign({}, state, {
        orgId: action.orgId,
        regFields: action.regFields,
        showRegister: action.showRegForm,
        registerFields: action.registerFields,
        currentForm: action.currentForm,
        roles: action.roles,
      });
    case TOGGLE_FORM:
      return Object.assign({}, state, {
        currentForm: action.form,
      });
    case SET_VALUE_FOR:
      return Object.assign({}, state, {
        loginFields: action.fields,
      });
    case SET_ATTEMPTING_LOGIN:
      return Object.assign({}, state, {
        attemptingLogin: action.bool,
      });
    case SET_SIGNIN_ERR:
      return Object.assign({}, state, {
        signinErrMsg: action.err,
      });
    case SET_SUBDOMAIN:
      return Object.assign({}, state, {
        subdomain: action.domain,
      });
    case HANDLE_ERROR:
      return Object.assign(
        {},
        state,
        errorOpts(action.err, action.errCode, action.errType),
      );
    case TOGGLE_FORGOT_PASS:
      return Object.assign({}, state, {
        forgotPass: action.bool,
        signinErrMsg: '',
      });
    case SUBMIT_FORGOT_PASS:
      return Object.assign({}, state, {
        forgotPassSubmitted: action.bool,
        signinErrMsg: '',
      });
    case SET_FOR_PASS_FIELDS_VAL:
      return Object.assign({}, state, {
        forgotPassFields: action.fields,
      });
    case SET_REG_FIELDS:
      return Object.assign({}, state, {
        registerFields: action.fields,
      });
    case SET_PASS_ERRMSG:
      return Object.assign({}, state, {
        passErrMsg: action.passErrMsg,
      });
    case PASS_TXT_TYPE:
      return Object.assign({}, state, {
        passwordTxtType: state.passwordTxtType === 'text' ? 'password' : 'text',
      });
    case TOGGLE_DROPDOWN:
      return Object.assign({}, state, {
        filterDropdown: action.bool,
      });
    case SELECT_FILTER:
      return Object.assign({}, state, {
        currentRole: action.role,
        filterDropdown: false,
      });
    case SET_REG_COMPLETE:
      return Object.assign({}, state, {
        registerComplete: action.bool,
        sessionId: action.sessionId,
      });
    case SET_COOKIE_MSG:
      return Object.assign({}, state, {
        cookieMsg: action.bool,
      });
    case SET_ALIAS_INFO:
      return Object.assign({}, state, {
        validationTxt: action.validationTxt,
        // showRegForm: action.showRegForm,
      });
    default:
      return Object.assign({}, state);
  }
}

export default signIn;



// WEBPACK FOOTER //
// ./src/reducers/routeReducers/signIn.js